import { Component, Injector } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ArtifactBaseComponent } from '../artifact-base-component';
import { AppWizService } from 'src/app/core/services/app-wiz.service';

@Component({
  selector: 'app-attestation',
  templateUrl: './attestation.component.html',
  styleUrls: ['./attestation.component.scss']
})
export class AttestationComponent extends ArtifactBaseComponent {
  constructor(
    private injector: Injector,
    private fb: FormBuilder,
    public override appWizService: AppWizService,
  ) {
    super(injector);
    this.interalForm = this.fb.group({
      confirmation: [null, [Validators.required]]
    });
    this.interalForm.valueChanges.subscribe(this.validateSection.bind(this));
  }

  initJsonData(): void {
    this.jsonData = this.jsonData || { attestation: null };
    this.jsonData.attestation = this.jsonData.attestation || {};
    if (this.jsonData.attestation.confirmation !== undefined) {
      this.interalForm.patchValue({
        confirmation: this.jsonData.attestation.confirmation ? 'Yes' : 'No'
      });
    }
  }

  validateJsonData() {
    this.artifact.sectionValid = this.interalForm.valid && this.interalForm.value.confirmation != null;
  }

  resetJsonData() {
    this.artifact.isArtifactUpdated = true;
    this.jsonData.attestation = {};
    this.interalForm.reset();
  }

  onSelectionChange() {
    this.artifact.isArtifactUpdated = true;
    this.validateSection();
  }

  override processBeforeSubmit() {
    const val = this.interalForm.value.confirmation;
    this.jsonData = { attestation: { confirmation: val === 'Yes' } };
  }
}
